module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/alarms2-1dd793e10f6d047567581ff236ec5a37.png";